export default __webpack_public_path__ + "static/media/illu_fusee.ec438953.png";